import axios from 'axios';
import logger from '../utils/logger';

// const API_URL = 'https://api.rapidlearningcycles.xantage.co';
const API_URL = import.meta.env.REACT_APP_API_URL || 'https://api.spark.rapidlearningcycles.com';

// Create axios instance with auth header
const getAuthHeader = () => {
  const user = JSON.parse(localStorage.getItem('user'));
  return user?.access_token ? { Authorization: `Bearer ${user.access_token}` } : {};
};

// Report AI service - handles both KG and KD
const reportAiService = {
  processKGMessage: async (message, reportId = null, reportContext = null, modelId = null, sessionId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/report-ai/message`,
        {
          message,
          report_id: reportId,
          report_context: reportContext,
          report_type: 'knowledge_gap',
          model_id: modelId,
          session_id: sessionId  // Add this parameter
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error from KG report AI service:', error);
      throw error;
    }
  },
  

  // CLEAR CONVERSATION MEMORY

  clearReportSession: async (reportId = null, reportType = 'knowledge_gap', sessionId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/report-ai/clear-session`,
        {
          report_id: reportId,
          report_type: reportType,
          session_id: sessionId
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error clearing report session:', error);
      throw error;
    }
  },

  processKDMessage: async (message, reportId = null, reportContext = null, modelId = null, sessionId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/report-ai/message`,
        {
          message,
          report_id: reportId,
          report_context: reportContext,
          report_type: 'key_decision',
          model_id: modelId,
          session_id: sessionId  // Add this parameter
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error from KD report AI service:', error);
      throw error;
    }
  },
  
  // Evaluate a KG report
  evaluateKGReport: async (reportData, modelId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/report-ai/evaluate`,
        {
          report_data: reportData,
          report_type: 'knowledge_gap',
          model_id: modelId
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error evaluating KG report:', error);
      throw error;
    }
  },
  
  // Evaluate a KD report
  evaluateKDReport: async (reportData, modelId = null) => {
    try {
      const response = await axios.post(
        `${API_URL}/report-ai/evaluate`,
        {
          report_data: reportData,
          report_type: 'key_decision',
          model_id: modelId
        },
        { headers: getAuthHeader() }
      );
      return response.data;
    } catch (error) {
      logger.error('Error evaluating KD report:', error);
      throw error;
    }
  },

  checkArchive: async (reportData, reportType, modelId = null) => {
    try {
      // Send full report data to backend - no truncation needed
      // Backend will handle chunking intelligently by sections
      const response = await axios.post(
        `${API_URL}/report-ai/check-archive`,
        {
          report_data: reportData,  // Send full report
          report_type: reportType,  // 'knowledge_gap' or 'key_decision'
          max_results: 10,
          model_id: modelId
        },
        { headers: getAuthHeader() }
      );

      return response.data;
    } catch (error) {
      logger.error('Error checking archive:', error);
      throw error;
    }
  }
};


export default reportAiService;